import { createStyles } from '@material-ui/core';

const styles = () => createStyles({
  root: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridAutoRows: '1fr',
  },
  menuItem: {
    maxWidth: 'inherit',
  },
});

export default styles;
